import {StateSelector} from "@integration-frontends/common/utils/redux";
import {brandfolderAdapter} from "../entities/brandfolder";
import {Brandfolder} from "@integration-frontends/workflow-manager/core/model";
import {EntityState} from "@reduxjs/toolkit";

export function createBrandfolderSelectors(stateSelector: StateSelector<EntityState<Brandfolder>>) {
  return brandfolderAdapter.getSelectors(stateSelector);
}
